import { Group, Switch, UnstyledButton } from '@mantine/core';
import { useEffect } from 'react';
import HoverCard from '@ui/components/HoverCard/HoverCard';
import Text from '@ui/components/Text/Text';
import Icon from '@ui/components/Icon/Icon';
import GuestHash from '@projects/models/guestHash';

import useInviteLink from './useInviteLink';

type InviteLinkProps = {
	projectID: number;
	guestHash: GuestHash;
	onInviteLinkChange?: ( guestHash: GuestHash ) => void;
}

const InviteLink = ( { projectID, guestHash, onInviteLinkChange }: InviteLinkProps ) => {
	const {
		showSuccessMessage,
		copyShareLink,
		boxStyles,
		onLinkEnabledToggled
	} = useInviteLink( { guestHash, projectID } );

	useEffect( () => {
		onInviteLinkChange?.( guestHash );
	}, [ guestHash, onInviteLinkChange ] );

	return (
		<Group position="apart" px={8} h={36} style={boxStyles} className="InviteLink">
			<Group spacing={6}>
				<Switch
					size="xs"
					checked={guestHash.enabled}
					onChange={onLinkEnabledToggled}
				/>
				<Text variant="footnote" color="var(--color-text-primary)">{guestHash.role.name}</Text>
				<HoverCard position="bottom" offset={6} withArrow withinPortal>
					<HoverCard.Target>
						<div style={{ display: 'flex', alignItems: 'center', paddingTop: 2 }}>
							<Icon icon="info_outlined" size={14} color="var(--color-text-secondary)" />
						</div>
					</HoverCard.Target>
					<HoverCard.Dropdown style={{ maxWidth: 220, padding: '7px 8px', backgroundColor: '#061324', border: 'none', borderRadius: 4 }}>
						<Text variant="caption-regular" color="white" style={{ textAlign: 'center' }}>
							{guestHash.role.description}
						</Text>
					</HoverCard.Dropdown>
				</HoverCard>
			</Group>
			{guestHash.enabled && (
				<UnstyledButton onClick={copyShareLink} style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
					<Icon icon="link" size={18} color="var(--color-primary-base)" />
					<Text variant="footnote-semibold" color="var(--color-primary-base)">
						{showSuccessMessage ? 'Copied' : 'Copy'}
					</Text>
				</UnstyledButton>
			)}
		</Group>
	);
};

export default InviteLink;
